import React, { useCallback } from "react";
import { GlobalSearchBar } from "@muchbetteradventures/styleguide";
var REFINEMENT_KEY = "mba-search-refinement";

var getPersistedRefinement = function getPersistedRefinement() {
  return sessionStorage.getItem(REFINEMENT_KEY) || "";
};

var SearchBox = function SearchBox(_ref) {
  var currentRefinement = _ref.currentRefinement,
      inputRef = _ref.inputRef,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Search our adventures" : _ref$placeholder,
      _refine = _ref.refine;
  var refine = useCallback(function (refinement) {
    if (sessionStorage) sessionStorage.setItem(REFINEMENT_KEY, refinement);

    _refine(refinement);
  }, [_refine]);
  var handleKeyDown = useCallback(function (event) {
    if (event.key === "Escape") {
      if (currentRefinement === "") {
        if (onClose) onClose();
      } else {
        refine("");
      }
    }
  }, [currentRefinement, onClose, refine]);
  var handleSubmit = useCallback(function (event) {
    event.preventDefault();
    if (onSubmit) onSubmit();
  }, [onSubmit]);
  var handleChange = useCallback(function (event) {
    return refine(event.currentTarget.value);
  }, [refine]);
  var handleClose = useCallback(function () {
    if (currentRefinement) refine("");else if (onClose) onClose();
  }, [currentRefinement, refine, onClose]);
  return /*#__PURE__*/React.createElement(GlobalSearchBar, {
    onClickClose: handleClose,
    onInputChange: handleChange,
    onKeyDown: handleKeyDown // check this works
    ,
    onSubmit: handleSubmit,
    placeholder: placeholder,
    ref: inputRef,
    value: currentRefinement
  });
};

export { getPersistedRefinement };
export default SearchBox;